import Video from 'app/components/tv/models/video';

const START_TIME = 0;

export default class SporttotalVideo extends Video {
  get startTime(): number {
    return START_TIME;
  }

  get videoDuration(): null {
    return null;
  }

  isSeekable(): boolean {
    return true;
  }

  manuallyEndAt(): number | null {
    return null;
  }

  showFuPaTvLogo(): boolean {
    return false;
  }
}
